<template>
  <div>
    <el-dialog
      title="Edit Track"
      :visible="dialog_track"
      width="30%"
      top="3vh"
      :modal="true"
      @close="close"
    >
      <div class="image">
        <div v-if="!image && !previewImage" class="image--uploader">
          <label for="imageFile" class="image-uploader"><i class="el-icon-plus fa-2x"></i></label>
          <input type="file" id="imageFile" accept="image/png, image/jpeg, image/jpg" v-show="false" @change="uploadImage">
        </div>
        <div v-else class="image--preview">
          <img height="120" width="120" :src="image ? image : previewImage" alt="image">
          <div class="overlay" @click="removeImage">
            <el-button
                class="btn-remove"
                icon="fas fa-trash"
                circle
            ></el-button>
          </div>
        </div>
      </div>
      <el-form ref="track" :model="track" label-position="top"> 
        <el-form-item label="Title" prop="title" required>
          <el-input type="text" v-model="track.title" clearable />
        </el-form-item>
        <el-form-item label="ISRC" prop="isrc">
          <el-input type="text" v-model="track.isrc" clearable />
        </el-form-item>
        <el-form-item label="Spotify link" prop="spotify_link">
          <el-input type="text" v-model="track.spotify_link" clearable />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button
          type="primary"
          size="mini"
          :loading="loading"
          @click="submit()"
        >
          Save
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'

export default {

  data() {
    return {
      fileList: [],
      url: process.env.VUE_APP_ADMIN_API_URL,
      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') },
      selectedImage: null,
      previewImage: null
    }
  },

  computed: {
    ...mapState('artistTracks', [
      'loading',
      'track',
      'dialog_track'
    ]),
    image() {
      return this.track.image_url instanceof File ? null : this.track.image_url
    }
  },

  methods: {
    ...mapActions('artistTracks', ['update']),
    ...mapMutations('artistTracks', [
      'setDialogTrack',
      'setImage'
    ]),

    submit() {
      if (this.selectedImage) this.setImage(this.selectedImage)
      this.update()
    },

    close(){
      this.setDialogTrack(false)
    },

    uploadImage(event) {
      if (event.target.files && event.target.files[0]) {
        let base64 = null
        // Encode the file using the FileReader API
        const reader = new FileReader();
        reader.onloadend = () => {
          // Use a regex to remove data url part
          this.selectedImage = reader.result
        };
        reader.readAsDataURL(event.target.files[0]);
        this.previewImage = URL.createObjectURL(event.target.files[0])
      }
    },

    removeImage() {
      this.track.image_url = null
      this.setImage(null)
      this.selectedImage = null
      this.previewImage = null
    },
  }
}
</script>

<style scoped lang="scss">

.image {
  &--uploader {
    label {
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 0 auto;
      width: 120px;
      height: 120px;
      border: 1px dashed #d9d9d9;
      cursor: pointer;
    }
  }
  &--preview {
    text-align: center;
    position: relative;

    img{
      object-fit: cover;
    }

    &:hover {
      .overlay {
        display: flex;
        .btn-remove{
          background: red;
          color: white;
          margin-top: unset;
          cursor: pointer;
        }
      }
    }

    .overlay {
      position: absolute;
      z-index: 5;
      top: 0;
      left: 50%;
      transform: translateX(-50%);
      width: 120px;
      height: 100%;
      background: rgba(0, 0, 0, .1);
      display: none;
      align-items: center;
      justify-content: center;
    }
  }
}
label.el-checkbox {
  display: inline-block;
}
</style>
